// SCROLL-TO ANIMATION FOR ANCHOR LINKS
// FADE-IN-UP ELEMENTS ON SCROLL
// FORM
// FORM SUCCESS SCROLL
// PLACE SLOT MODULE INSIDE THE LP


//
// =SCROLL-TO ANIMATION FOR ANCHOR LINKS
// --------------------------------------------------

$('.msdw-page-scroll').click(function() {
  if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
    var target = $(this.hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
    if (target.length) {
      var offsetValue = 0;
      if ( window.innerWidth <= 767 ) {
        offsetValue;
        // console.log(offsetValue);
      } else {
        offsetValue = 59;
        // console.log(offsetValue);
      }

      $('html,body').animate({
        scrollTop: target.offset().top - offsetValue
      }, 900);
      return false;
    }
  }
});


//
// =FADE-IN-UP ELEMENTS ON SCROLL
// --------------------------------------------------

const elements = document.querySelectorAll(".msdw-animate");

function check(entries) {
  entries.map((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add("msdw-animated");
      observer.unobserve(entry.target);
    }
  });
}

const observer = new IntersectionObserver(check);

elements.forEach((elem) => observer.observe(elem));


//
// =FORM
// --------------------------------------------------

const forms = document.querySelectorAll('.jwsdw-raffleForm');

Array.from(forms).forEach((form) => {
  if (form) {
    form.addEventListener('raffle:submitted', (e) => {
      // let response = e.detail;
      // if (response.isNewUser) {
      //     //do smth for newly registered users
      // } else {
      //     //do smth for already registered users
      // }
      form.classList.add('jwsdw-lottery-is-successful');
    });
  }
});


//
// =FORM SUCCESS SCROLL
// --------------------------------------------------

var elForm = document.querySelector('.jwsdw-raffleForm');

if (elForm) {
  var observerForm = new MutationObserver(function (event) {
    $("html, body").animate({
        scrollTop: $("#sectionForm").offset().top - 64,
      }, 500);
  });

  observerForm.observe(elForm, {
    attributes: true,
    attributeFilter: ['class'],
    childList: false,
    characterData: false
  });
}

//
// =PLACE SLOT MODULE INSIDE THE LP
// --------------------------------------------------
const NL_Subs_Slot = document.getElementById('NL_Subs_Slot');
const catLandingBottom1 = document.getElementById('cat-landing-bottom1');
catLandingBottom1 && NL_Subs_Slot.appendChild(catLandingBottom1);
